/**
 * Created by eric on 4/13/16.
 */
'use strict';

module.exports = function(angularModule) {

  angularModule.factory('reviewGenService', function ($q, $http, $rootScope, campaignManagerService) {

    function ReviewGenService() {
      this.campaignListData = null;
      this.campaignListDataPromise = null;
      this.testPromise = function (data) {
        var deferred = $q.defer();
        deferred.resolve(data);
        return deferred.promise;
      }
    }

    ReviewGenService.prototype.searchCampaignContacts = function (filters, refresh) {
      return $http.get('/v5/reviewBuilder/campaign/contact', {params: filters})
    };

    ReviewGenService.prototype.addContact = function (contact) {
      return $http.post('/v5/reviewBuilder/campaign/contact/create', contact).then(response => {
        return response
      });
    };

    ReviewGenService.prototype.disableContact = function (id) {
      return $http.put('reviewBuilder/campaign/contact/disable/' + id);
    };

    ReviewGenService.prototype.enableContact = function (id) {
      return $http.put('reviewBuilder/campaign/contact/enable/' + id);
    };

    ReviewGenService.prototype.updateStatusContacts = function (ids, enable) {
      return $http.put('/v5/reviewBuilder/campaign/contact/status', {contactIds: ids, enable: enable});
    };

    ReviewGenService.prototype.restartContact = function (contact) {
      return $http.put('/v5/reviewBuilder/campaign/contact/restart', contact);
    };

    ReviewGenService.prototype.getContact = function (id, contact) {
      return $http.get('/v5/reviewBuilder/campaign/contact/get/' + id)
    };

    ReviewGenService.prototype.getContactReviewCount = function (id, contact) {
      return $http.get('/v5/reviewBuilder/campaign/contact/getReviewCount/' + id).then(response => response.data);
    };

    ReviewGenService.prototype.updateContact = function (contact, moveExistingReviews) {
      return $http.put('/v5/reviewBuilder/campaign/contact/update', {contact, moveExistingReviews})
    };

    ReviewGenService.prototype.deleteContact = function (contact) {
      return this.deleteContacts([contact._id.$oid]);
    }

    ReviewGenService.prototype.deleteContacts = function (ids) {
      return $http.delete('/v5/reviewBuilder/campaign/contact/delete', {params: {contactIds: ids}}).then(response => {
        ids.map(id => $rootScope.$broadcast('contactDeleted', {_id: id}))
        return response
      });
    }

    let formPromise = null;
    ReviewGenService.prototype.searchReviewForms = function (filters) {
      return formPromise = $http.get('/v5/reviewBuilder/form', {params: filters})
        .finally(() => formPromise = null);
    };

    ReviewGenService.prototype.addReviewForm = function (reviewForm) {
      return $http.post('/v5/reviewBuilder/form/create', reviewForm).then(response => {
        $rootScope.$broadcast('reviewFormCreated', {reviewForm: response.data});
        return response
      });
    };

    ReviewGenService.prototype.getReviewForm = function (id) {
      return $http.get('/v5/reviewBuilder/form/get/' + id)
    };

    ReviewGenService.prototype.updateReviewForm = function (reviewForm) {
      return $http.put('/v5/reviewBuilder/form/' + reviewForm._id, reviewForm)
    };

    ReviewGenService.prototype.deleteReviewForm = function (reviewForm) {
      return $http.delete('/v5/reviewBuilder/form/delete/' + reviewForm._id).then(response => {
        $rootScope.$broadcast('reviewFormDeleted', {reviewForm: reviewForm});
        return response
      });
    };

    // Proxies to the campaign manager
    ReviewGenService.prototype.listCampaigns = function() {
      return campaignManagerService.listCampaigns()
    }
    ReviewGenService.prototype.searchCampaigns = function(filters) {
      return campaignManagerService.searchCampaigns(filters);
    }
    ReviewGenService.prototype.getCampaign = function(id) {
      return campaignManagerService.getCampaign(id);
    }
    ReviewGenService.prototype.getCampaignMeta = function(campaignIds) {
      return campaignManagerService.getCampaignMeta(campaignIds);
    }
    ReviewGenService.prototype.updateCampaign = function(campaign) {
      return campaignManagerService.saveCampaign(campaign);
    }
    ReviewGenService.prototype.deleteCampaign = function(campaign,deleteReviews) {
      return campaignManagerService.deleteCampaign(campaign,deleteReviews);
    }

    ReviewGenService.prototype.getEmailTemplates = function (id) {
      return $http.get("/v5/reviewBuilder/emailTemplate" + (id ? '/' + encodeURIComponent(id) : '')).then(function (result) {
        return result.data;
      })
    };

    let emailPromise = null
    ReviewGenService.prototype.searchEmailTemplates = function (filters) {
      var options = {params: filters};
      return emailPromise = $http.get("/v5/reviewBuilder/emailTemplate", options).then(function (result) {
        return result.data;
      })
      .finally(() => emailPromise = null);
    };

    ReviewGenService.prototype.saveEmailTemplate = function (id, emailTemplate) {
      var uri;
      if (id) {
        uri = "/v5/reviewBuilder/emailTemplate/" + encodeURIComponent(id);
      } else {
        uri = "/v5/reviewBuilder/emailTemplate"
      }

      if(!emailTemplate.content){ //add content back in if Ace has removed it b/c of empty html
        emailTemplate.content = "";
      }

      return $http.post(uri, emailTemplate).then(response => {
        $rootScope.$broadcast(`email${id ? 'Updated' : 'Created'}`, {email: response.data})
        return response
      });
    };

    ReviewGenService.prototype.deleteEmailTemplate = function (emailTemplate) {
      return $http.delete("/v5/reviewBuilder/emailTemplate/" + encodeURIComponent(emailTemplate._id)).then(response => {
        $rootScope.$broadcast('emailDeleted', {email: emailTemplate});
        return response
      });
    };

    ReviewGenService.prototype.submitReview = function (generatedReview) {
      return $http.post("/reviewBuilder/form/submission", generatedReview)
    }

    ReviewGenService.prototype.searchReviews = function (filters) {
      return $http.get("/v5/reviewBuilder/campaign/generatedReview", {params: filters})
    };

    ReviewGenService.prototype.searchReviewsInAdaptedFormat = function (filters) {
      return $http.get("/v5/reviewBuilder/campaign/generatedReviewAdapted", {params: filters})
    };

    ReviewGenService.prototype.getReview = function(reviewId, campaignId) {
      return $http.get(`/v5/reviewBuilder/campaign/${encodeURIComponent(campaignId)}/generatedReview/${encodeURIComponent(reviewId)}`)
        .then(resp => resp.data);
    };

    /** Used to ensure all required keys are present in requests to the server */
    function formPrototype() {
      return {
        name: '',
        dynamicFields: [],
        template: '',
        thankYouTemplate: ''
      }
    }


    ReviewGenService.prototype.previewAlertTemplate = function (form) {
      let formRequest = angular.copy(form, formPrototype());
      ['name','template', 'thankYouTemplate'].map(field => {               // Make sure required keys still exist
        if (typeof formRequest[field] === "undefined") {            // ACE editor likes to set them to undefined
          formRequest[field] = "";
        }
      })
      return $http.post("/reviewBuilder/template/preview/form", formRequest);
    };

    function emailPrototype() {
      return {
        name: '',
        content: '',
        templateType: 'email'
      }
    }

    ReviewGenService.prototype.previewEmailTemplate = function (emailTemplate) {
      let emailRequest = angular.copy(emailTemplate, emailPrototype());
      ['name', 'content'].map(field => {               // Make sure required keys still exist
        if (typeof emailRequest[field] === "undefined") {            // ACE editor likes to set them to undefined
          emailRequest[field] = "";
        }
      })
      return $http.post("/reviewBuilder/template/preview/email", emailRequest);
    };

    ReviewGenService.prototype.getSampleEmailTemplates = function () {
      return $http.get("/reviewBuilder/emailTemplate/").then(function (response) {
        return response.data;
      })
    };

    ReviewGenService.prototype.sendTestEmail = function (emailTemplate, emailAddress) {
      return $http.post("/v5/reviewBuilder/emailTemplate/" + emailTemplate._id + "/test", {
        "toEmailAddress": emailAddress
      })
    };

    ReviewGenService.prototype.search = function () {
      return this.testPromise();
    };

    ReviewGenService.prototype.list = function () {
      return this.testPromise();
    };

    ReviewGenService.prototype.insert = function () {
      return this.testPromise();
    };

    ReviewGenService.prototype.findOne = function () {
      return this.testPromise();
    };

    ReviewGenService.prototype.update = function () {
      return this.testPromise();
    };

    ReviewGenService.prototype.remove = function () {
      return this.testPromise();
    };

    ReviewGenService.prototype.export = function () {
      return this.testPromise();
    };

    let reportPromise = null;
    ReviewGenService.prototype.getCampaignReport = function (campaignId,params) {
      if (reportPromise !== null) {
        return reportPromise;
      }

      return reportPromise = $http.get('/v5/reviewBuilder/campaign/dashboard/' + campaignId, {params})
        .finally(() => reportPromise = null);
    };

    ReviewGenService.prototype.findNewCampaignContacts = function (campaignId) {
      return $http.get('/reviewBuilder/campaign/dashboard/' + encodeURIComponent(campaignId) + '/newContacts')
        .then(function (response) {
          return response.data.contacts
        });
    };

    let widgetPromise = null;
    ReviewGenService.prototype.searchWidgets = function (filters, refresh) {
      return widgetPromise = $http.get('/v5/reviewBuilder/widget', {params: filters})
        .finally(() => widgetPromise = null);
    };

    ReviewGenService.prototype.addWidget = function (widget) {
      return $http.post('/v5/reviewBuilder/widget/create', widget).then(response => {
        $rootScope.$broadcast('widgetCreated', widget);
        return response
      });
    };

    ReviewGenService.prototype.getWidget = function (id) {
      return $http.get('/v5/reviewBuilder/widget/get/' + id)
    };

    ReviewGenService.prototype.updateWidget = function (widget) {
      return $http.put('/v5/reviewBuilder/widget/' + encodeURIComponent(widget._id), widget)
    };

    ReviewGenService.prototype.deleteWidget = function (widget) {
      return $http.delete('/v5/reviewBuilder/widget/' + encodeURIComponent(widget._id))
        .then(response => {
          $rootScope.$broadcast('widgetDeleted', {widget: widget});
        })
    };

    ReviewGenService.prototype.getFirstReview = function (refresh) {
      return $http.get('reviewBuilder/widget/firstReview')
    };

    ReviewGenService.prototype.searchImages = function (refresh) {
      return $q.when([]);
      //return $http.get('reviewBuilder/widget/firstReview')
    };


    ReviewGenService.prototype.addReviewResponse = (revGenReviewId, response, isPublic) => {
      return $http({
        method: 'POST',
        url: '/reviewBuilder/responseForm/owner/response?revGenReviewId=' + revGenReviewId + '&isPublic=' + isPublic,
        data: $.param({'response':response, 'isPublic': isPublic}),
        headers: {'Content-Type': 'application/x-www-form-urlencoded'}
      }).then(response => response.data)
    }

    return new ReviewGenService();

  })
};

